<template>
  <b-dropdown-item
    :disabled="isLoading"
    @click="downloadFile()"
  >
    <b-spinner
      v-if="isLoading"
      label="Spinning"
      small
    />
    <slot />
  </b-dropdown-item>
</template>

<script>
import { BDropdownItem, BSpinner } from 'bootstrap-vue'
import downloadQueueMixin from '@/libs/download-queue-mixin'

export default {
  name: 'DownloadFile',
  components: {
    BDropdownItem, BSpinner,
  },
  mixins: [downloadQueueMixin],
}
</script>
